/* Purchase the exact three variants shown in the current curated look. */
if (!customElements.get('melody-look-purchase')) {
  customElements.define('melody-look-purchase', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.pending || this.closest('[data-look]')?.hidden) return;
        this.pending = true;
        const button = form.querySelector('button[type="submit"]');
        const label = button.querySelector('[data-purchase-label]');
        const error = form.querySelector('.melody-look-purchase__error');
        const originalLabel = label.textContent;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        label.textContent = form.dataset.loadingLabel;
        error.hidden = true;
        try {
          const data = new FormData(form);
          const items = [...data.entries()].filter(([key]) => /^items\[\d+\]\[id\]$/.test(key)).map(([,id]) => ({id:Number(id),quantity:1}));
          if (!items.length) throw new Error('Empty look');
          if (!items.every(item => Number.isSafeInteger(item.id) && item.id > 0)) throw new Error('Invalid look');
          const response = await fetch(`${form.action}.js`, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart update failed');
          const result = await response.json();
          if (!Array.isArray(result.items) || !items.every(item => result.items.some(added => Number(added.variant_id || added.id) === item.id))) {
            throw new Error('Incomplete cart response');
          }
          window.location.assign(data.get('return_to'));
        } catch (cause) {
          // A request can succeed before its response is interrupted. Do not add again automatically.
          form.querySelector('[data-purchase-error]').textContent = form.dataset.errorLabel;
          error.hidden = false;
          label.textContent = originalLabel;
          form.removeAttribute('aria-busy');
          button.disabled = true;
        }
      }, { signal: this.controller.signal });
      const reset = () => {
        this.pending = false;
        form.removeAttribute('aria-busy');
        const button = form.querySelector('button[type="submit"]');
        button.disabled = false;
        const label = button.querySelector('[data-purchase-label]');
        label.textContent = this.readyLabel;
      };
      this.readyLabel = form.querySelector('[data-purchase-label]').textContent;
      window.addEventListener('pageshow', event => { if (event.persisted) reset(); }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

